import * as tslib_1 from "tslib";
import { Button, LabeledCheckbox, Select } from '@nextiva/next-ui';
import { toCustomDateRange } from "../../../../utils/date-range";
import { map, times } from 'lodash';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import "./RelativeOptions.css";
var UNIT_OPTIONS = [{
  value: 'minute',
  label: 'Minutes'
}, {
  value: 'hour',
  label: 'Hours'
}, {
  value: 'day',
  label: 'Days'
}, {
  value: 'week',
  label: 'Weeks'
}, {
  value: 'month',
  label: 'Months'
}, {
  value: 'year',
  label: 'Years'
}];
var ROUND_LABELS = {
  minute: 'Rounded to nearest minute',
  hour: 'Rounded to nearest hour',
  day: 'Rounded to 12:00 AM',
  week: 'Rounded to Monday',
  month: 'Rounded to 1st of month',
  year: 'Rounded to 1st January'
};

var RelativeOptions =
/** @class */
function (_super) {
  tslib_1.__extends(RelativeOptions, _super);

  function RelativeOptions(props) {
    var _this = _super.call(this, props) || this;

    _this.getLabel = function (dateRange) {
      var timezone = _this.props.timezone;
      var start = toCustomDateRange(dateRange, timezone).start;
      return moment.tz(start, timezone).format('MMMM Do hh:mm A');
    };

    _this.setLabel = function () {
      var _a = _this.state,
          value = _a.value,
          unit = _a.unit,
          round = _a.round;

      _this.setState({
        label: _this.getLabel({
          type: 'relative',
          value: value,
          unit: unit,
          round: round
        })
      });
    };

    _this.handleValueChange = function (_a) {
      var value = _a.value;
      var round = _this.state.round;

      _this.setState({
        value: value,
        round: value !== 0 ? round : true
      }, _this.setLabel);
    };

    _this.handleUnitChange = function (_a) {
      var value = _a.value;

      _this.setState({
        unit: value
      }, _this.setLabel);
    };

    _this.handleRoundChange = function (checked) {
      _this.setState({
        round: checked
      }, _this.setLabel);
    };

    _this.handlePresetClick = function (presetDateRange) {
      return function () {
        _this.setState(presetDateRange, _this.setLabel);
      };
    };

    _this.handleSave = function () {
      var _a = _this.state,
          value = _a.value,
          unit = _a.unit,
          round = _a.round;

      _this.props.onSave({
        type: 'relative',
        value: value,
        unit: unit,
        round: round
      });
    };

    _this.getOptions = function () {
      var unit = _this.state.unit;
      return UNIT_OPTIONS.filter(function (option) {
        return _this.props.units.includes(option.value) || option.value === unit;
      });
    };

    _this.getPresets = function () {
      return Object.keys(_this.props.presets).reduce(function (acc, presetKey) {
        if (_this.props.units.includes(_this.props.presets[presetKey].unit)) {
          acc[presetKey] = _this.props.presets[presetKey];
        }

        return acc;
      }, {});
    };

    _this.getValueOptionsCount = function (unit) {
      switch (unit) {
        case 'day':
          return 91;

        default:
          return 61;
      }
    };

    _this.getValueOptions = function (countElements) {
      return times(countElements, function (value) {
        return {
          value: value,
          label: value.toString()
        };
      });
    };

    var initialDateRange = {
      type: 'relative',
      value: props.value,
      unit: props.unit,
      round: props.round
    };
    _this.state = tslib_1.__assign({}, initialDateRange, {
      label: _this.getLabel(initialDateRange)
    });
    return _this;
  }

  RelativeOptions.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        value = _a.value,
        unit = _a.unit,
        round = _a.round,
        label = _a.label;
    var options = this.getOptions();
    var availablePresets = this.getPresets();
    var valueOptionsCount = this.getValueOptionsCount(unit);
    var valueOptions = this.getValueOptions(valueOptionsCount);
    return React.createElement("div", {
      className: "drp-relative-options"
    }, React.createElement("div", {
      className: "drp-relative-options__label"
    }, React.createElement("span", null, label), " to now"), React.createElement("div", {
      className: "drp-relative-options__filter"
    }, React.createElement("span", {
      className: "drp-relative-options__prefix"
    }, "Filter from"), React.createElement(Select, {
      className: "drp-relative-options__value",
      portalMenuWrapperClassName: "drp-relative-options__value-list",
      options: valueOptions,
      value: value,
      onChange: this.handleValueChange
    }), React.createElement(Select, {
      className: "drp-relative-options__unit",
      portalMenuWrapperClassName: "drp-relative-options__unit-list",
      options: options,
      value: unit,
      onChange: this.handleUnitChange
    }), React.createElement("span", {
      className: "drp-relative-options__suffix"
    }, "ago to now.")), React.createElement(LabeledCheckbox, {
      containerClassName: "drp-relative-options__round",
      checked: round,
      disabled: value === 0,
      label: ROUND_LABELS[unit] || 'Rounded',
      size: 14,
      onChange: this.handleRoundChange
    }), React.createElement("div", {
      className: "drp-relative-options__footer"
    }, React.createElement("div", {
      className: "drp-relative-options__presets"
    }, map(availablePresets, function (preset, presetLabel) {
      return React.createElement("span", {
        key: presetLabel,
        onClick: _this.handlePresetClick(preset)
      }, presetLabel);
    })), React.createElement(Button, {
      kind: "success",
      className: "drp-popover__btn-update",
      onClick: this.handleSave
    }, "Update")));
  };

  return RelativeOptions;
}(Component);

export default RelativeOptions;